<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #f2f6fc">
    <Title :title="{ name: '项目交付申请', path: '/item/delivery' }"></Title>
    <el-card class="box-card" style="min-height: 650px; margin-top: 15px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="left"
        label-width="150px"
      >
        <el-divider content-position="left">项目信息</el-divider>
        <el-form-item label="所属项目" prop="projectId">
          <el-select
            style="width: 50%"
            v-model="ruleForm.projectId"
            placeholder="请选择所属项目"
            filterable
          >
            <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.projectName"
              :disabled="item.projectState === 6"
              :value="item.projectId"
            >
              <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
              <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
              <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交付类型" prop="deliveryTypeList" required>
          <el-checkbox-group v-model="deliveryTypeList" @change="handleDeliveryChange">
            <el-checkbox label="1">系统评估</el-checkbox>
            <el-checkbox label="2">方案评估</el-checkbox>
            <el-checkbox label="3">方案编制</el-checkbox>
            <el-checkbox label="4">密码应用</el-checkbox>
            <el-checkbox label="5">密码整改</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="ruleForm.contact" type="textarea" rows=3 maxlength="300"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" rows=5 maxlength="300" v-model="ruleForm.remarks" ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="submitShow" type="primary" @click="submitForm">提交申请</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Title from "@/components/Title";
import {requestDelivery,requestAllProject,requestApplyDetail} from "@/api";

export default {
  components: { Title },
  data() {
    return {
      submitShow: true,
      projectList: [],
      contractList: [],
      deliveryTypeList: [],
      ruleForm: {
        projectId: "",
        contact: "",
        remarks: "",
        deliveryTypeList: [],
      },
      rules: {
        projectId: [
          { required: true, message: "请选择所属项目", trigger: "blur" },
        ],
        contact: [
          { required: true, message: "联系方式不能为空", trigger: "blur" },
        ],
        deliveryTypeList: [
          { required: true, message: '请选择至少一种交付类型', trigger: 'change' }
        ]
      },
    };
  },

  created() {
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getObject()
    }
    this.getAllProject()
  },
  methods: {
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    submitForm() {
      this.submitShow = true
      this.$refs['ruleForm'].validate(async (isPass) => {
        if (isPass) {
          let param = this.ruleForm
          // 重新申请需要的参数
          if (this.reapply) {
            param.applyId = this.applyId
          }

          param.deliveryTypeList = this.ruleForm.deliveryTypeList.join(',')
          console.log('准备重新申请了',param)
          const res = await requestDelivery(param)
          if (res.code === 200) {
            if (this.reapply) {
                this.$router.push({query: {}})
                this.reapply = false
              }
            this.$message.success(res.msg)
            this.$refs['ruleForm'].resetFields()
            this.deliveryTypeList = []
          } else {
            this.$message.error(res.msg)
          }
        }
        this.submitShow = true
      })
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.ruleForm = res.object.detail
            this.deliveryTypeList = res.object.detail.deliveryType.split(',')
            this.ruleForm.deliveryTypeList = this.deliveryTypeList
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    handleDeliveryChange(val) {
      this.ruleForm.deliveryTypeList = val;
    },
  }
};
</script>
